<template>
  <q-layout view="lHh Lpr lFf">
    <Header />
    <q-page-container>
      <q-page padding>
        <div class="row q-pt-lg text-grey-9">
          <div class="col"></div>
          <div class="col-5" style="max-width: 600px">
            <span class="text-h5">
              <q-icon name="fas fa-ban" color="negative" size="2rem"/>
              Oops !
            </span>
            <q-separator class="q-mt-sm"/>
            <div class="q-mt-lg">
              <p>
                La page demandée n'existe pas ou vous n'avez pas l'autorisation d'y accéder...
              </p>
            </div>
            <div>
              <q-btn
                label="Retour"
                @click="goBack"
                class="text-white bg-grey-9"
              />
              <q-btn
                label="Connexion"
                to="/login"
                color="white"
                class="q-ml-sm text-grey-9"
              />
            </div>
          </div>
          <div class="col"></div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import Header from '~/components/Header';

export default {
  components: {
    Header,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>